<template>
  <div id="Article">
    <div class="ArticleBanner" :style="{backgroundImage:'url('+bannerImg+')'}"></div>
    <div class="Article-content">
      <div class="Article-content-inner">
        <p class="Article-title">{{title}}</p>
        <p class="Article-subtitle" v-if="subtitle">——{{subtitle}}</p>
        <p class="Article-time">发布时间 : {{time}}<br><span v-if="author">作者 : {{author}}</span></p>
        <div class="Article-inner" v-html="article"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Article',
  data:function(){
    return{
      title:'',
      subtitle:'',
      time:'',
      article:'',
      categories:[],
      bannerImg:'',
      author:''
    }
  },
  created(){
    this.title = ''
    this.subtitle = ''
    this.time = ''
    this.article = ''
    this.$store.dispatch('getArticle',this.$route.query.id).then(res => {
      this.title = res.data.title
      $('title').text(res.data.title)
      this.time = res.data.release_time
      this.subtitle = res.data.sub_title
      this.article = res.data.content
      this.categories = res.data.categories
      this.bannerImg = res.data.category_image.image
      this.author = res.data.author
      if(res.data.categories.length>0){
        this.$parent.menuActiveId = res.data.categories[0].id
      }
    })
  },
  watch:{
    '$route':function(val,oldval){
      this.title = ''
      this.subtitle = ''
      this.time = ''
      this.article = ''
      this.$store.dispatch('getArticle',this.$route.query.id).then(res => {
        this.title = res.data.title
        $('title').text(res.data.title)
        this.time = res.data.release_time
        this.subtitle = res.data.sub_title
        this.article = res.data.content
        this.categories = res.data.categories
        this.bannerImg = res.data.category_image.image
        this.author = res.data.author
        if(res.data.categories.length>0){
          this.$parent.menuActiveId = res.data.categories[0].id
        }
      })
    }
  }
}
</script>

<style lang="scss">
#Article {
  background-color: #f9f9f9;
  .ArticleBanner{
    width: 100%;
    height: 175px;
    position: absolute;
    background-size: cover;
    background-repeat:no-repeat;
    background-position: center;
  }
  .Article-content{
    position: relative;
    width: calc(100% - 20px);
    padding: 155px 10px 20px 10px;
    a:any-link{ color: #289ee1; }
    a:-webkit-any-link{ color: #289ee1; }
    .Article-content-inner{
      border-radius: 4px;
      background-color: #ffffff;
      -webkit-border-radius: 4px;
      min-height: calc(100vh - 338px);
      padding: 16px 10px 20px 10px;
      .Article-title{
        color: #282828;
        font-size: 16px;
        overflow: hidden;
        line-height: 24px;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .Article-subtitle{
        color: #282828;
        font-size: 14px;
        margin-top: 4px;
        line-height: 16px;
        text-align: center;
        padding-bottom: 12px;
      }
      .Article-time{
        color: #282828;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
      }
      .Article-inner{
        width: 100%;
        margin-top: 9px;
        img{max-width: 100%;}
      }
      .Article-inner:after{content:"";display:block;clear:both;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Article/index.vue